
import CommonUtils from "@/common-utils";
import Constants from "@/constants";
import axios from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";
import Layout from "./Layout.vue";
import { LayoutOVO } from "./vo/main.vo";

@Component({ components: { Layout } })
export default class Promotion extends Vue {
  @Prop({ default: "" })
  layoutCd!: number;
  layoutOVO = {} as LayoutOVO;

  currentSubMenuIdx = 0;

  created() {
    axios.get(`/promotion/${this.layoutCd}`).then((r) => {
      this.layoutOVO = r.data;
      CommonUtils.setDocumentTitle([this.layoutOVO.layout.layoutNm]);
      CommonUtils.setMetaDiscription(this.layoutOVO.layout.description);
      CommonUtils.setHeadLink(this.$route.fullPath.slice(1));

      // 프로모션 GTag전송
      CommonUtils.sendCommonEventLogs(this, Constants.CUSTOM_PROMOTION_VIEW, {promotionId: this.layoutOVO.layout.layoutCd, promotionName: this.layoutOVO.layout.layoutNm});
      // 찐로그
      CommonUtils.log(this.$route.name, this.layoutOVO.memCd, {lc: this.layoutCd});
    }).catch(()=>{
      this.$router.push({name: "Main"});
    });
  }
}
